import React, { CSSProperties, useEffect, useMemo } from "react";
import { createPortal } from "react-dom";
import { TStyle } from "../models/TStyle";

export default React.memo(function TutorialBackdrop({
    isActive,
    forDialog,
    style,
}: {
    forDialog?: boolean;
    isActive: boolean;
    style?: TStyle;
}) {
    useEffect(() => {
        const scroll = (e: Event) => {
            e.preventDefault();
        };
        if (isActive) {
            document.body.addEventListener("wheel", scroll, { passive: false });
        }
        return () => {
            document.body.removeEventListener("wheel", scroll);
        };
    }, [isActive]);

    const defaultStyle = useMemo(() => {
        const style: CSSProperties = {
            margin: 0,
            position: "fixed",
            pointerEvents: "auto",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: forDialog ? 1400 : 1100,
        };
        return style;
    }, [forDialog]);

    const positionStyle = (position: "top" | "bottom" | "left" | "right") => {
        switch (position) {
            case "top":
                return {
                    top: "0",
                    left: style?.left,
                    bottom: style?.top,
                    width: style?.width,
                    height: style?.top,
                };
            case "bottom":
                return {
                    top: style?.height + style?.top,
                    left: style?.left,
                    width: style?.width,
                    height: "200dvh",
                };
            case "left":
                return {
                    top: 0,
                    width: style?.left,
                    height: "100dvh",
                    left: "0",
                };
            case "right":
                return {
                    top: 0,
                    left: style?.width + style?.left,
                    height: "200dvh",
                    right: "0",
                };
        }
    };

    return createPortal(
        <>
            {isActive && style && (
                <>
                    <div
                        className="backdrop-top"
                        style={{ ...defaultStyle, ...positionStyle("top") }}
                    ></div>
                    <div
                        className="backdrop-bottom"
                        style={{ ...defaultStyle, ...positionStyle("bottom") }}
                    ></div>
                    <div
                        className="backdrop-left"
                        style={{ ...defaultStyle, ...positionStyle("left") }}
                    ></div>
                    <div
                        className="backdrop-right"
                        style={{ ...defaultStyle, ...positionStyle("right") }}
                    ></div>
                </>
            )}
            {isActive && !style && (
                <div
                    role="dialog"
                    aria-modal="true"
                    className="backdrop-center"
                    style={{ ...defaultStyle, inset: 0 }}
                ></div>
            )}
        </>,
        document.body
    );
});
